export default __webpack_public_path__ + "locales/nl/Notifications.json?hash=71e6121eddd1ee40bfc03107b36f24e9";